import React from 'react';
import PropTypes from 'prop-types';
import Container from '../styled/Container';
import SecondHeader from '../styled/SecondHeader';

function CategoryList({ categories }) {
  return (
    <Container margin="50px 0 0 0" alignitem="left" right="unset">
      <SecondHeader paddingbottom="12px">Categories</SecondHeader>
      <ul className="category_list">
        {categories.map((category) => (
          <li className="list_of_category" key={category.category}>{category.category}</li>
        ))}
      </ul>
    </Container>
  );
}

CategoryList.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.string.isRequired,
    }),
  ).isRequired,
};
export default CategoryList;
